import React from 'react';
import { Link } from 'react-router-dom';
import { PackageCheck } from 'lucide-react';

const SIZES = {
  sm: { box: 'w-8 h-8', icon: 16, text: 'text-lg' },
  md: { box: 'w-10 h-10', icon: 24, text: 'text-2xl' },
  lg: { box: 'w-16 h-16', icon: 32, text: 'text-5xl' },
};


export default function CoreSellLogo({
  size = 'md',
  showText = true,
  className = '',
  to = '/',
  variant = 'light',
}) {
  const s = SIZES[size] || SIZES.md;
  const textClass = variant === 'light' ? 'text-white' : 'text-slate-800';

  const content = (
    <div className={`flex items-center gap-2 ${className}`}>
      <div
        className={`${s.box} rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg shadow-blue-500/30 shrink-0`}
      >
        <PackageCheck size={s.icon} className="text-white" strokeWidth={2} />
      </div>
      {showText && (
        <span className={`font-bold ${s.text} tracking-tight ${textClass}`}>
          Core<span className="text-blue-400">Sell</span>
        </span>
      )}
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="no-underline hover:opacity-90 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
}
